<style></style>

<template>
    <div class="page-container">
        <section-collapse id="provider-training-delivery-options" accordion="provider-training">
            <template #title> Training Delivery Options </template>
            <template #collapsed-content>
                When providing the Build the Skills with Be Active Kids training you have flexibility in how it’s delivered: 
                in-person, virtual, or hybrid. Review these delivery options as you are planning your training sessions.
                <br/>
                <a :href="$basePath + '/be-active-kids/bts_training_delivery_options.pdf'" target="_blank">Training Delivery Options</a>
            </template>
        </section-collapse>

        <section-collapse id="provider-training-slides" accordion="provider-training">
            <template #title> Training Slides </template>
            <template #collapsed-content>
                The trainings slides are what you will present at your Build the Skills with Be Active Kids trainings. 
                The slides are divided into three sessions. Review and practice the slides prior to your training sessions.
                <br/>
                <a :href="$basePath + '/be-active-kids/bts_provider_training_slides.pptx'" target="_blank">Provider Training Slides</a>
            </template>
        </section-collapse>

        <section-collapse id="provider-training-script" accordion="provider-training">
            <template #title> Training Script </template>
            <template #collapsed-content>
                Use the training script to follow along with the training slides. The script can be used to guide your 
                facilitation of the Build the Skills with Be Active Kids training sessions. You may want to modify the 
                script based off of your chosen delivery option.
                <br/>
                <a :href="$basePath + '/be-active-kids/bts_provider_training_script.pdf'" target="_blank">Provider Training Script</a>
            </template>
        </section-collapse>

        <section-collapse id="provider-training-handout" accordion="provider-training">
            <template #title> Training Handout </template>
            <template #collapsed-content>
                The training handout can be provided to participants prior to the Build the Skills with Be Active Kids 
                training sessions. The handout shares each slide of the training presentation for participants to follow along.
                <br/>
                <a :href="$basePath + '/be-active-kids/bts_provider_training_handout.pdf'" target="_blank">Provider Training Handout</a>
            </template>
        </section-collapse>
        <section-collapse id="provider-training-handout" accordion="provider-training">
            <template #title> Training Supply List </template>
            <template #collapsed-content>
                Review the training supply list for a detailed list of resources needed to conduct in-person and virtual Built the Skills with Be Active Kids training sessions.
                <br/>
                <a :href="$basePath + '/be-active-kids/bts_training_supply_list.pdf'" target="_blank">Provider Training Handout</a>
            </template>
        </section-collapse>

        <section-collapse id="provider-training-recruitment-flyer" accordion="provider-training">
            <template #title> Recruitment Flyer </template>
            <template #collapsed-content>
                Share the recruitment flyer as you are promoting the Build the Skills with Be Active Kids training to interested 
                child care providers in your community. 
                <br/>
                <a :href="$basePath + '/be-active-kids/bts_provider_recruitment_flyer.pdf'" target="_blank">Recruitment Flyer</a>
            </template>
        </section-collapse>

        <section-collapse id="provider-training-homework-assignments" accordion="provider-training">
            <template #title> Keep it Up Assignments </template>
            <template #collapsed-content>
                You can support child care providers in keeping up all of their new 
                improvements by sharing Keep It Up Assignments. These assignments are optional, but 
                strongly encouraged.
                <br/>
                <a :href="$basePath + '/be-active-kids/bts_keep_it_up.pdf'" target="_blank">Keep it Up Assignments</a>
            </template>
        </section-collapse>

        <section-collapse id="provider-training-video-list" accordion="provider-training">
            <template #title>Sample Be Active Kids Movement Guide Videos</template>
            <template #collapsed-content>
                All of the Be Active Kids Movement Guide samples mentioned in the training slides and script can be accessed 
                using the video list. Prior to holding your Build, the Skills with Be Active Kids training sessions, make sure 
                you have downloaded and saved these videos for easy access during your training.
                <br/>
                <a :href="$basePath + '/be-active-kids/bak_video_lists.pdf'" target="_blank">YouTube Playlist</a>
            </template>
        </section-collapse>

        <section-collapse id="provider-training-certificate" accordion="provider-training">
            <template #title> Provider Training Certificate </template>
            <template #collapsed-content>
                Once you have completed your Build the Skills with Be Active Kids training sessions, you can print out or 
                electronically share the Provider Training Certificate with participants. The template provided allows you to 
                enter the name of each participant who has completed your training. Check with your state lead to determine if 
                the Build the Skills with Be Active Kids training is available for contact hours.
                <br/>
                <a :href="$basePath + '/be-active-kids/bts_provider_certificate.pdf'" target="_blank" disabled>Provider Training Certificate</a>
            </template>
        </section-collapse>
    </div>
</template>

<script>
    import VideoModal from '../../materials/VideoModal'
    import SectionCollapse from '../SectionCollapse.vue';

    export default {
        components: {
            VideoModal,
            SectionCollapse
        },
        data() {
            return {
                showModal: false
            }
        },
        methods: {},
        computed: {
            OrientationtrainingVideo: () => {
                return {
                    url: 'https://www.youtube.com/watch?v=7zIyqBowkfw',
                    title: 'orientation video'
                }
            }
        }
    }
</script>